import React from 'react';
import type { Job } from '../../types/career';
export function JobSummaryCard({
  job,
  onApply
}: {
  job: Job;
  onApply: () => void;
}) {
  const facts = [{
    label: 'Department',
    value: job.department
  }, {
    label: 'Location',
    value: job.location
  }, {
    label: 'Work mode',
    value: job.mode
  }, {
    label: 'Type',
    value: job.type
  }, {
    label: 'Level',
    value: job.level
  }];
  return <aside aria-label="Job summary" className="rounded-[14px] border border-canvas-line bg-white p-6" data-id="element-273" data-mp="3ked4yj1nfmft">
      <p className="text-[17px] font-semibold text-ink" data-id="element-274" data-mp="3pej38i2fc76v">{job.title}</p>
      <dl className="mt-5 space-y-3.5" data-id="element-275" data-mp="3ap3bozv2jxq4">
        {facts.map(f => <div key={f.label} className="flex justify-between gap-4 text-[14px]" data-id="element-276" data-mp="3aotkxa279mjd">
            <dt className="text-ink-muted" data-id="element-277" data-mp="3fmvdqmpfh081">{f.label}</dt>
            <dd className="text-right font-medium text-ink" data-id="element-278" data-mp="78mtc1x27fqy">{f.value}</dd>
          </div>)}
      </dl>
      <button type="button" onClick={onApply} className="mt-6 inline-flex h-12 w-full items-center justify-center rounded-[7px] bg-brand text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-hover" data-id="element-279" data-mp="bzmph4ycttse">
        Apply now
      </button>
      <p className="mt-4 text-center text-[13px] text-ink-muted" data-id="element-280" data-mp="19nvi9m07yvis">
        Posted {job.posted} · Apply by {job.applyBy}
      </p>
    </aside>;
}